import {createApp} from 'vue'
import App from './App.vue'
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.min.js';
import {Popup, ActionBar, ActionBarIcon, ActionBarButton, Swipe, NoticeBar, SwipeItem,Icon} from 'vant';
import 'vant/lib/index.css';

const app = createApp(App);
app.use(Swipe);
app.use(SwipeItem);
app.use(NoticeBar);
app.use(ActionBar);
app.use(Popup);
app.use(ActionBarIcon);
app.use(ActionBarButton);
app.use(Icon);
app.mount('#app')
